import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setInitialFuelData } from 'store/device.slice';
import ControlRoomAPI from 'api/control-room.api';

/**
 * Fetches the latest fuel snapshot once on mount (and whenever the
 * customer changes) so Control Room shows fuel data immediately instead
 * of waiting for the first SSE push. Live updates continue to arrive via
 * useControlRoomSSE / patchLiveDeviceState afterwards.
 */
export function useControlRoomFuel() {
  const dispatch = useAppDispatch();
  const accessToken = useAppSelector((s) => s.authReducer.accessToken);
  const customerId = useAppSelector((s) => s.persistedReducer.customer.id);
  const controlRoomApi = useRef(new ControlRoomAPI()).current;

  useEffect(() => {
    if (!accessToken || !customerId) return;

    let cancelled = false;

    void (async () => {
      try {
        const response = await controlRoomApi.getLatestFuelData();
        if (cancelled) return;
        dispatch(setInitialFuelData(response?.devices ?? []));
      } catch (err) {
        console.error('[control-room-fuel] fetch error:', err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [accessToken, customerId]);
}
